import React, { Component } from 'react'
import LOGO from '../img/No data@3x.png'
 class Nodataerror extends Component {
    render() {
        let img={
            width: this.props.width
        }
        let divbody={
            marginTop:this.props.marginTop,
            textAlign: "center",
             color: "gray",
            fontWeight: "bold"
        }
        return (
            <div>
            <div style={divbody}>
            <img height="200px" width="200px" style={{alignItems:"center"}} src={LOGO} alt="No Data"></img>
            <h5 style={{color:"grey",textAlign:"center"}}>{this.props.msg}</h5>
            </div>
            </div>
        )
    }
}

export default Nodataerror
